import { type Common } from './common.js';
import { type OffsetPaginationResponse } from './models/common.js';
import type * as Pharmacy from './models/pharmacy.js';
import { type ImportValidation } from './models/provider.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(
    args: Pharmacy.FindAllOptions
  ): Promise<OffsetPaginationResponse<Pharmacy.PharmacyWithAddress>> {
    const url = this.common.constructPath(`/pharmacies`, args);
    return await this.common.getJSON(url);
  }

  async import(
    pharmacies: Partial<Omit<Pharmacy.PrevisitPharmacy, 'id' | 'staticMapUrl'>>[]
  ): Promise<Pharmacy.Pharmacy[]> {
    const url = this.common.constructPath(`/pharmacies`);
    return await this.common.putJSON(url, { pharmacies: pharmacies });
  }

  async verifyImport(
    values: Record<string, string>[]
  ): Promise<Record<string, ImportValidation>[]> {
    const url = this.common.constructPath(`/pharmacies/import/verify`);
    return await this.common.postJSON(url, values);
  }

  async findVerifiedPharmacies(args: {
    q?: string;
    page: number;
    limit: number;
    state?: string;
    googlePlaceId?: string;
  }): Promise<Pharmacy.PrevisitPharmacy[]> {
    const url = this.common.constructPath(`/patient-previsit/pharmacies`, args);
    return await this.common.getJSON(url);
  }
}
